<script>
import { BNavbar } from "bootstrap-vue";

export default {
  extends: BNavbar
};
</script>